// extracted by mini-css-extract-plugin
module.exports = {"dateContainer":"styles_dateContainer__3XJQg"};